import React, { useContext } from "react";
import { Skeleton, Table } from "antd";
import FlowstationPerformanceStore from "../store/FlowstationPerformanceStore";

import { createContext } from "react";
import { Observer } from "mobx-react-lite";
import { commaFormating } from "../../../../Utility/modules/helpers";
import _ from "underscore";
const flowstationPerformanceStoreCtx = createContext(
  FlowstationPerformanceStore
);
export const FlowstationUtilizationCard = () => {
  const flowstationPerformanceStore = useContext(
    flowstationPerformanceStoreCtx
  );
  const applyFormatting = (text, record, index) => {
    const params = { value: Math.round(text, 0) };
    return commaFormating(params);
  };
  const columns = [
    {
      title: "Flowstation",
      dataIndex: "flowstation",

      align: "left",
      key: "flowstation",
    },
    {
      title: <b className="header-table">Oil Capacity Utilization</b>,
      dataIndex: "oilUtilization",

      align: "center",
      render: applyFormatting,
    },
    {
      title: <b>Gas Capacity Utilization</b>,
      dataIndex: "gasUtilization",

      align: "center",
      render: applyFormatting,
    },

    {
      title: <b>Boe Utilization</b>,
      dataIndex: "boeUtilization",

      align: "center",
      render: applyFormatting,
    },
  ];
  const alternateRows = (record, index) =>
    index % 2 ? "table-row" : " table-row table-row-alternate2";

  return (
    <Observer>
      {() =>
        flowstationPerformanceStore.isLoading ? (
          <>
            <div style={{ padding: "15px" }}>
              <Skeleton active />
              <Skeleton active />
              <Skeleton active />
            </div>
          </>
        ) : (
          <Table
            title={() => (
              <h5
                className="ant-typography"
                style={{
                  display: "inline-block",

                  color: "red",
                }}
              >
                NAOC Flowstations Capacity Utilization (%){" "}
              </h5>
            )}
            dataSource={_.sortBy(
              [...flowstationPerformanceStore.flowstationUtilization.values()],
              "flowstation"
            )}
            columns={columns}
            pagination={false}
            size="small"
            rowKey="flowstation"
            rowClassName={alternateRows}
          />
        )
      }
    </Observer>
  );
};

